/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
export type Base_Unit_Type_Enum =
  | 'BAG'
  | 'BAG_IN_BOX'
  | 'BOTTLE'
  | 'BOX'
  | 'BOX_SET'
  | 'BULK'
  | 'CAN'
  | 'CARTON'
  | 'CUP'
  | 'FLASK'
  | 'JAR'
  | 'KEG'
  /**   */
  | 'NET'
  | 'PACK'
  | 'PIECE'
  | 'SACHET'
  | 'SLICE'
  | 'SPRAY'
  | 'TIN'
  | 'TRAY'
  /**   */
  | 'TUB'
  | 'TUBE';

export type Billing_Type_Enum =
  /** billed per unit */
  | 'FIXED'
  /** billed per measured weight */
  | 'WEIGHT_DEPENDENT';

export type Measurement_Unit_Enum =
  | 'CL'
  | 'G'
  | 'KG'
  | 'L'
  | 'ML'
  | 'T'
  /** Used to count units in logistical packages */
  | 'UNIT';

export type Product_Label_Name_Enum =
  | 'AGRICULTURE_BIOLOGIQUE'
  | 'APPELLATION_ORIGINE_CONTROLEE'
  | 'APPELLATION_ORIGINE_PROTEGEE'
  | 'ECOCERT_ECODETERGENT'
  | 'GOUTEZ_ARDECHE'
  | 'HAUTE_VALEUR_ENVIRONNEMENTALE'
  | 'INDICATION_GEOGRAPHIQUE_PROTEGEE'
  | 'LABEL_ROUGE'
  | 'LE_PORC_FRANCAIS'
  | 'NATURE_ET_PROGRES'
  | 'ORIGINE_FRANCE_GARANTIE'
  | 'PRODUIT_ILE_DE_FRANCE'
  | 'SAVEURS_DE_NORMANDIE'
  | 'VALEURS_PARC_NATUREL_REGIONAL';

export type Trade_Item_Unit_Descriptor_Enum =
  | 'CASE'
  | 'CRATE'
  | 'DISPLAY'
  | 'HALF_CASE'
  | 'PALLET'
  | 'SACK'
  /** Used when base units are sold individually */
  | 'UNIT';

export type PackagingHistoryFragmentFragment = { id: string, company_id: string | null, content_measurement_unit: Types.Measurement_Unit_Enum | null, gtin: string | null, trade_item_unit_descriptor: Types.Trade_Item_Unit_Descriptor_Enum, unit_quantity: number | null, net_content: number | null, sku: number, price: number, base_unit: { id: string, gtin: string | null, sku: number | null, content_measurement_unit: Types.Measurement_Unit_Enum | null, unit_quantity: number | null, unit_type: Types.Base_Unit_Type_Enum | null, billing_type: Types.Billing_Type_Enum, unit_net_content: number | null, main_photo: { domain: string | null, path: string } | null, photos: Array<{ photo: { domain: string | null, path: string } | null }> } | null, product: { id: string, name: string, sku: number, sub_family: string, vat_rate: number | null, ingredients: string | null, allergens: string | null, calories: number | null, calories_kj: number | null, fat: number | null, saturated_fat: number | null, carbohydrate: number | null, sugars: number | null, sodium: number | null, protein: number | null, labels: Array<{ label: Types.Product_Label_Name_Enum }> } | null };

export const PackagingHistoryFragmentFragmentDoc = /*#__PURE__*/ gql`
    fragment packagingHistoryFragment on packaging_history {
  id
  company_id
  base_unit {
    id
    gtin
    sku
    content_measurement_unit
    unit_quantity
    unit_type
    billing_type
    unit_net_content
    billing_type
    main_photo {
      domain
      path
    }
    photos {
      photo {
        domain
        path
      }
    }
  }
  content_measurement_unit
  gtin
  product {
    id
    name
    sku
    sub_family
    vat_rate
    labels {
      label
    }
    ingredients
    allergens
    calories
    calories_kj
    fat
    saturated_fat
    carbohydrate
    sugars
    sodium
    protein
  }
  trade_item_unit_descriptor
  unit_quantity
  net_content
  sku
  price
}
    `;